import axios from 'axios'
import { get } from '@/api/base'
import { convertToCamelCase } from '@/models/utils/casing'
import { useQuery } from '@tanstack/vue-query'
import { MaybeRef } from '@vueuse/core'
import { computed, unref } from 'vue'
import moment from 'moment'

const endpoint = '/api/v5/organizations'

export interface OrganizationResponse {
  id: string
  name: string
}

function getGuestConnectedOrganizationToThisOrganization(
  organizationId: string,
  signal?: AbortSignal,
) {
  const source = axios.CancelToken.source()
  const result = get<OrganizationResponse[]>(
    `${endpoint}/connected-guest-companies?organizationId=${organizationId}`,
    {
      cancelToken: source.token,
    },
  ).then((res) => convertToCamelCase(res.data))

  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query')
  })

  return result as unknown as Promise<OrganizationResponse[]>
}

export function useGetGuestConnectedOrganizationToThisOrganization(
  organizationId: MaybeRef<string | undefined>,
) {
  const organizationIdComputed = computed(() => unref(organizationId))
  const queryKey = computed(() => [
    'organizations',
    'guest-connected-org',
    organizationIdComputed.value,
  ])
  const enabled = computed(() => {
    return organizationIdComputed.value !== null && organizationIdComputed.value !== undefined
  })
  return useQuery({
    queryKey,
    queryFn: ({ signal }) =>
      getGuestConnectedOrganizationToThisOrganization(organizationIdComputed.value!, signal),
    staleTime: moment.duration(10, 'minutes').asMilliseconds(),
    enabled,
  })
}
